export default __webpack_public_path__ + "static/media/advantage-4.d51abf8e.png";